import React, { FC } from 'react';

import Plus from '@gravity-ui/icons/Plus';
import Xmark from '@gravity-ui/icons/Xmark';
import { Button, Icon, TextInput } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { Field } from 'client/blocks-redesign/form/Field/Field';
import * as keyset from 'i18n/AppForm';

import styles from './FieldList.module.scss';

const t = i18n(keyset);

type Props = {
    values: string[];
    errors?: string[];
    name?: string;
    label: React.ReactNode;
    onChange: (values: string[]) => void;
    disabled?: boolean;
    description?: React.ReactNode;
    required?: boolean;
};

export const FieldList: FC<Props> = ({ label, errors, required, disabled, onChange, description, values }) => {
    return (
        <Field
            fieldTitle={label}
            fieldDescription={description}
            required={required}
            error={errors?.length ? errors?.map((error, index) => `#${index} - ${error}`).join(' ') : undefined}
        >
            {values.map((phraseText, index) => (
                <TextInput
                    className={styles.formElement}
                    errorMessage={errors?.[index]}
                    key={index}
                    onChange={(e) => {
                        const copiedPhrases = [...values];
                        copiedPhrases[index] = e.target.value;
                        onChange(copiedPhrases);
                    }}
                    value={phraseText}
                    disabled={disabled}
                    rightContent={
                        <Button
                            onClick={() => {
                                const updatedPhrases = [...values];
                                updatedPhrases.splice(index, 1);
                                onChange(updatedPhrases);
                            }}
                            view="flat"
                            disabled={disabled}
                        >
                            <Icon data={Xmark} />
                        </Button>
                    }
                    size="xl"
                />
            ))}
            <Button className={styles.formButton} onClick={() => onChange([...values, ''])} disabled={disabled}>
                <Icon data={Plus} />
                {t('add')}
            </Button>
        </Field>
    );
};
